export default __webpack_public_path__ + "static/media/me-active.d5fd843a.webp";